module.exports = __webpack_public_path__ + "img/2_Appendix.48a31a15.png";